import { useRef, useState } from 'react';
import { Camera, Upload } from 'lucide-react';
import CameraCapture from './CameraCapture.jsx';

// Two buttons: Take photo and Upload. On a phone, Take photo opens the
// phone's own camera (best focus and quality); on a computer, where browsers
// ignore that, it opens our live camera pop-up. Upload picks existing photos.
// onFiles gets an array of Files/Blobs.
const touch = () => typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches;

export default function PhotoButtons({ onFiles, multiple = false, disabled = false, takeLabel = 'Take photo', primary = false, title }) {
  const camera = useRef(null);
  const files = useRef(null);
  const [live, setLive] = useState(false);
  const picked = (e) => {
    const list = [...(e.target.files || [])];
    e.target.value = '';
    if (list.length) onFiles(list);
  };
  return (
    <div className="photo-add">
      <button type="button" className={`btn with-icon${primary ? ' primary' : ''}`} disabled={disabled} onClick={() => (touch() ? camera.current?.click() : setLive(true))}>
        <Camera size={18} aria-hidden="true" /> {takeLabel}
      </button>
      <button type="button" className="btn with-icon" disabled={disabled} onClick={() => files.current?.click()}>
        <Upload size={18} aria-hidden="true" /> Upload
      </button>
      <input ref={camera} type="file" accept="image/*" capture="environment" hidden onChange={picked} />
      <input ref={files} type="file" accept="image/*" multiple={multiple} hidden onChange={picked} />
      {live && (
        <CameraCapture
          title={title || takeLabel}
          onPhoto={(blob) => onFiles([blob])}
          onClose={() => setLive(false)}
          onFallback={() => { setLive(false); files.current?.click(); }}
        />
      )}
    </div>
  );
}
